import { useState, useRef } from 'react';

const usePullToRefresh = (onRefresh, threshold = 80) => {
  const [isPulling, setIsPulling] = useState(false);
  const [pullDistance, setPullDistance] = useState(0);
  const startY = useRef(null);
  const currentY = useRef(null);

  const onTouchStart = (e) => {
    // Only start if at top of page
    if (window.scrollY === 0) {
      startY.current = e.targetTouches[0].clientY;
    }
  };

  const onTouchMove = (e) => {
    if (!startY.current) return;
    if (window.scrollY > 0) {
      startY.current = null;
      return;
    }

    currentY.current = e.targetTouches[0].clientY;
    const distance = currentY.current - startY.current;

    // Only pull down (positive distance)
    if (distance > 0) {
      e.preventDefault(); // Prevent default scroll
      setPullDistance(Math.min(distance, threshold * 1.5));
      setIsPulling(distance > threshold);
    }
  };

  const onTouchEnd = async () => {
    if (!startY.current) return;

    if (pullDistance > threshold && onRefresh) {
      // Trigger haptic feedback
      if (navigator.vibrate) {
        navigator.vibrate(50);
      }

      // Show refreshing state
      setPullDistance(threshold);

      // Call refresh function
      await onRefresh();
    }

    // Reset
    startY.current = null;
    currentY.current = null;
    setIsPulling(false);
    setPullDistance(0);
  };

  return {
    onTouchStart,
    onTouchMove,
    onTouchEnd,
    isPulling,
    pullDistance
  };
};

export default usePullToRefresh;
